import React from "react";
import "../styles/team.css";
import metaData from "./metaData";
import IndividualMember from "./individualMember";
import { useScrollAnimation } from "../utils/useScrollAnimation";

function Team() {
  const membersRef = useScrollAnimation();
  
  return (
    <div id="team-page" className="team-block">
      <p className="section-eyebrow">People</p>
      <h1 className="section-title">Meet Our Team</h1>
      <div className="section-line" aria-hidden="true" />

      <div className="members scroll-animate-stagger" ref={membersRef}>
        <IndividualMember metaData={metaData.teamDetails.gb} />
        <IndividualMember metaData={metaData.teamDetails.shibu} />
        <IndividualMember metaData={metaData.teamDetails.saptadip} />
        <IndividualMember metaData={metaData.teamDetails.ala} />
        
        <IndividualMember metaData={metaData.teamDetails.atanu} />
        <IndividualMember metaData={metaData.teamDetails.sougata} />
        <IndividualMember metaData={metaData.teamDetails.akash} />
        <IndividualMember metaData={metaData.teamDetails.pritambar} />
        <IndividualMember metaData={metaData.teamDetails.ranajit} />
        <IndividualMember metaData={metaData.teamDetails.rahul} />
        <IndividualMember metaData={metaData.teamDetails.dipak} />
        <IndividualMember metaData={metaData.teamDetails.shreyashi} />
        <IndividualMember metaData={metaData.teamDetails.debjyoti} />
        <IndividualMember metaData={metaData.teamDetails.abhijit} />
        <IndividualMember metaData={metaData.teamDetails.supriyo} />
        <IndividualMember metaData={metaData.teamDetails.subhankar} />
        <IndividualMember metaData={metaData.teamDetails.asrafull} />
      </div>
    </div>
  );
}

export default Team;
